import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC, ReactNode } from 'react';
import { highlightRanges } from './highlightRanges';

/** `text` with the parts `query` matches wrapped in a `<mark>`. Unmatched text renders as is. */
export const HighlightedText: FC<{ text: string; query?: string }> = ({ text, query = '' }) => {
  const ranges = highlightRanges(text, query);
  if (ranges.length === 0) return <>{text}</>;

  const parts: Array<ReactNode> = [];
  let cursor = 0;
  for (const [start, end] of ranges) {
    if (start > cursor) parts.push(text.slice(cursor, start));
    parts.push(<Mark key={start}>{text.slice(start, end)}</Mark>);
    cursor = end;
  }
  if (cursor < text.length) parts.push(text.slice(cursor));

  return <>{parts}</>;
};

const Mark = styled.mark`
  background: ${RacemapColors.LightYellow};
  color: inherit;
`;
